<script>
export default {
    name: "CompletedProcedures",

    data() {

        return {
            procedures: [],
        };
    },

    mounted() {
        this.$root.loading=true;
        Promise.allSettled([ this.fetchProcedures(), ]).then(() => {
            this.$root.loading=false;
            setTimeout(() => {
                window.print();
            }, 250);
        }).catch(() => { this.$root.loading=false; });
    },

    methods: {

        fetchProcedures() {
            let url = `Theatre/GetCompletedProcedures`;
                url += `?Datefrom=${this.$route.query.DateFrom}`;
                url += `&Dateto=${this.$route.query.DateTo}`;
                url += this.$route.query.SearchText ? 
                    `&SearchText=${this.$route.query.SearchText}` : ``;
            return this.$http.get(url).then(response => {
                this.procedures = response.data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap mx-2">
        <tail-address-header></tail-address-header>
        <table class="table mt-3">
            <thead class="text-sm">
                <tr class="flex w-full">
                    <th class="p-tiny flex-1">Patient</th>
                    <th class="p-tiny flex-1">OP File No</th>
                    <th class="p-tiny flex-1">IP File No</th>
                    <th class="p-tiny w-1/5">Payment</th>
                    <th class="p-tiny flex-1">Treatment Details</th>
                    <th class="p-tiny flex-1">Request Date</th>
                    <th class="p-tiny flex-1">Done On</th>
                </tr>
            </thead>
            <tbody 
                class="text-sm flex flex-col items-center">
                <tr class="flex w-full" 
                    v-for="(procedure,idx) in procedures" :key="idx">
                    <td class="p-tiny flex-1">{{ procedure.patient }}</td>
                    <td class="p-tiny flex-1">{{ procedure.opfileno || `-` }}</td>
                    <td class="p-tiny flex-1">{{ procedure.ipfileno || `-` }}</td>
                    <td class="p-tiny w-1/5">{{ procedure.pmode }}</td>
                    <td class="p-tiny flex-1">{{ procedure.test }}</td>
                    <td class="p-tiny flex-1">{{ procedure.date | dateFormat }}</td>
                    <td class="p-tiny flex-1">{{ procedure.doneOn | dateFormat }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>